<template>
  <footer class="site-footer">
    <div class="container">
      <!-- EU Project logo -->
      <div class="row justify-content-center mb-4">
        <div class="col-lg-10">
          <div class="eu-project-logo">
            <ImageWithFallback
              :src="require('@/assets/logos/CEFoodCycle_Interreg.png')"
              :fallback-src="'/dev/images/logos/CEFoodCycle_Interreg.png'"
              alt="Interreg Alpine Space - Co-funded by the European Union - CEFoodCycle"
              img-class="img-fluid"
              loading="eager"
            />
          </div>
        </div>
      </div>

      <!-- Partner logos -->
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="partner-logos">
            <ImageWithFallback
              :src="require('@/assets/logos/Partnerlogos.jpeg')"
              :fallback-src="'/dev/images/logos/Partnerlogos.jpeg'"
              alt="Partner logos"
              img-class="img-fluid"
              loading="eager"
            />
          </div>
        </div>
      </div>

      <!-- EU co-funding statement -->
      <div class="row justify-content-center mt-3">
        <div class="col-lg-10 text-center">
          <p class="eu-funding-text">
            This project is co-funded by the European Union through the Interreg Alpine Space programme.
          </p>
        </div>
      </div>
      
      <!-- Navigation Links -->
      <div class="row mt-4">
        <div class="col-12">
          <div class="footer-links">
            <router-link to="/privacy-policy" class="footer-link">Privacy Policy</router-link>
            <a href="https://www.alpine-space.eu/project/cefoodcycle/" class="footer-link" target="_blank" rel="noopener noreferrer">
              CEFoodCycle Project
            </a>
            <router-link to="/privacy-policy#imprint" class="footer-link">Contact</router-link>
          </div>
        </div>
      </div>
      
      <!-- Copyright -->
      <div class="row mt-4">
        <div class="col-12 text-center">
          <p class="copyright">
            &copy; {{ new Date().getFullYear() }} CEFoodCycle - All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import ImageWithFallback from '@/components/ImageWithFallback.vue';

export default {
  name: 'Footer',
  components: {
    ImageWithFallback
  }
};
</script>

<style scoped>
.site-footer {
  background-color: white;
  padding: 3rem 0 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.eu-project-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 1.5rem;
}

.eu-project-logo img {
  max-height: 140px;
  width: auto;
}

.partner-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
}

.partner-logos img {
  max-height: 120px;
  width: auto;
}

.eu-funding-text {
  color: #555;
  font-size: 0.9rem;
  font-style: italic;
  margin: 0;
}

.footer-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
}

.footer-link {
  color: #555;
  text-decoration: none;
  transition: color 0.3s ease;
  font-weight: 500;
  padding: 0.5rem 0;
  position: relative;
}

.footer-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #87b140;
  transition: width 0.3s ease;
}

.footer-link:hover {
  color: #87b140;
}

.footer-link:hover::after {
  width: 100%;
}

.copyright {
  color: #888;
  font-size: 0.9rem;
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .footer-links {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  
  .eu-project-logo img {
    max-height: 100px;
  }

  .partner-logos img {
    max-height: 80px;
  }
  
  .site-footer {
    padding: 2rem 0 1.5rem;
  }
}
</style>